import { z } from 'zod';
/**
 * `/absent` (ADR 0080): "show me away now". No payload; the next intent that
 * counts (`countsAsActivity`) brings the player back.
 */
export const SetAwayMessageSchema = z.object({}).strict();
//# sourceMappingURL=away.js.map